import PropTypes from 'prop-types'
import React from 'react'
import HeroVideo from '../components/hero-video'

const CaseStudies = ({ caseStudies, awards, cta }) => (
  <div className='case-studies'>
    {caseStudies.map(({ node }) => (
      <div key={node.id} className='works-item'>
        <div className='works-item__video'>
          <HeroVideo
            desktopPosterSrc={node.image_desktop.url}
            mobilePosterSrc={node.image_mobile.url}
            desktopVideoSrc={node.loop_desktop.file.url}
            mobileVideoSrc={node.loop_mobile.file.url}
            desktopFullVideo={node.video_desktop}
            mobileFullVideo={node.video_mobile}
            node={node}
            aspectRatio='16:9'
            caseButton
            caseStudyVideo
            autoPlay={false}
            loopPlay
            hoverPlay
            cta={cta}
          />
        </div>
        <div className='works-item__details'>
          <span className='works-item__platform'>{node.eyebrow}</span>
          <h2 className='works-item__title'>{node.title}</h2>
          <div className='works-item__description'>
            <p>{node.description}</p>
          </div>
          {awards[node.eyebrow.toLowerCase()]
            ? <div className='works-item__awards'>
              {awards[node.eyebrow.toLowerCase()].map((award, index) => (
                <span key={index.toString()} className='works-item__award'>
                  <img src={award} alt='' />
                </span>))}
            </div>
            : null
          }
        </div>
      </div>
    ))}
  </div>
)

CaseStudies.defaultProps = {
  awards: {},
  cta: 'View the work'
}

CaseStudies.propTypes = {
  caseStudies: PropTypes.array,
  awards: PropTypes.object
}

export default CaseStudies



// WEBPACK FOOTER //
// ./src/components/case-studies.js